import merge from 'lodash/merge';
import {DividerProps} from './DividerProps.interface';

export function Divider({
  className,
  direction = 'horizontal',
  sizePx = 1,
  color,
  style,
  ...props
}: DividerProps) {
  return (
    <div
      className={className}
      style={merge(
        {
          height: direction === 'horizontal' ? sizePx : undefined,
          width: direction === 'vertical' ? sizePx : undefined,
          backgroundColor: color,
        },
        style
      )}
      {...props}
    />
  );
}
